<template>
  <div class="row">
    <div class="col-sm-12">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="form-group col-sm-12 col-md-12 required">
            <label for="account_id">Account:</label>
            <Select2 name="account_id" v-model.number="account_id" :options="accountOptions"/>
          </div>          
          <div class="form-group col-sm-12">
            <input class="btn btn-primary" required type="submit" value="Show" :disabled="this.onRequest">
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-12">
      <Datatable v-bind:entries="data" :columns="columns" :title="'Ceiba Devices'"/>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Datatable from '../components/Datatable.vue'
  import { getCapability } from '../_helpers'
  import Select2 from 'vue3-select2-component';
  export default {
    computed: {
      ...mapState('payment_links', ['payment_links', 'onRequest']),
      ...mapState('accounts', ['accounts']),
      ...mapState('users', ['user']),
      columns(){
        return [
            {name: 'created_at', text: 'Created', order: 'desc', raw: {
              type: 'Moment_UTC'
            }},
            {name: 'sales', text: 'Sales',
              raw: {
                type: 'Sub',
                value: 'sales_name'
              }
            },
            {name: 'sales', text: 'Sales Code',
              raw: {
                type: 'Sub',
                value: 'sales_code'
              }
            },
            {name: 'account', text: 'Account',
              raw: {
                type: 'Sub',
                value: 'account_name'
              }
            },
            {name: 'payment_name', text: 'Payment Name'},
            {name: 'payment_url', text: 'Payment Link'},
            {name: 'customer_name', text: 'Customer'},
            {name: 'customer_email', text: 'Customer Email'},
            {name: 'customer_phone', text: 'Customer Phone'},
            {name: 'gross_amount', text: 'Total Amount', class:'text-right', raw: {
              type: 'format_number'
            }},
            {name: 'transaction_status', text: 'Transaction Status'},
            {name: 'payment_type', text: 'Payment Type'},
            {name: 'transaction_time', text: 'Transaction Time', raw: {
              type: 'Moment'
            }},
            {name: 'settlement_time', text: 'Settlement Time', raw: {
              type: 'Moment'
            }},
            {name: 'action', text: 'Action',
              raw: {
                type: 'Action',
                fields: [
                  {event: 'edit_payment_link', text: 'View', method: 'get', class: 'btn btn-primary'},
                  getCapability('delete_payment_link', this.user) ? {event: 'payment_links/destroy', text: 'Delete', method: 'post', class: 'btn btn-danger ml-1'} : {},
                ]
              }
            },
          ]
      }
    },
    data(){
      return {
        account_id: null,
        accountOptions: [],
        data: [],
      }
    },
    components:{
      Datatable,
      Select2,
    },
    methods: {
      ...mapActions('payment_links', ['get_payment_link_by_account']),
      ...mapActions('accounts', ['get_all']),
      ...mapActions('alert', ['error', 'clear']),
      handleSubmit(){
        if(this.onRequest) return;
        this.clear()
        this.get_payment_link_by_account({account_id: this.account_id})
      },
    },
    created() {
      this.$emit('onChildInit', 'Payment Link', getCapability('add_payment_link', this.user) ? '/payment_links/add' : '')
      this.get_all()
    },
    watch: {
      accounts(nextState, prevState){
        if(nextState !== prevState){
          this.accountOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.accountOptions.push({id:item.id, text:item.account_name})
            })
            if(this.accountOptions.length > 0){
              this.account_id = this.accountOptions[0].id
              this.handleSubmit()
            }
          }
          return
        }
      },
      payment_links(nextState, prevState){
        if(nextState !== prevState){
          this.data = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.data.push({...item, ...{customer_name:item.customer_first_name + ' ' + item.customer_last_name}})
            })
          }
          return
        }
      },
    }
  }
</script>
